const boardType = {
    dashboardMessages: 1,
    messagesByNmm: 2,
    schedule: 4,
    promotion: 6,
}

export default boardType;